module.exports = __webpack_public_path__ + "static/media/gb.81a23f4e.png";